import React, {useContext} from "react";
import {Col, Container, Nav, Navbar, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useIntl} from "react-intl";
import messages from "../../../i18n/messages";
import {NavContext} from "../../../contexts/navigation/NavContext";

const NavigationBar = () => {
    const intl = useIntl();
    const [, setNavContext] = useContext(NavContext);
    const onNavLinkClick = (navLink) => {
        setNavContext(navLink);
    }
    return (
        <Row>
            <Col>&nbsp;</Col>
            <Col xs={12}>
                <Navbar bg="dark" data-bs-theme="dark">
                    <Container>
                        <Nav className="me-auto">
                            <Link className={'nav-link'} onClick={() => onNavLinkClick('/learning')} to={'/learning'}>{intl.formatMessage(messages.learningProgressLabel)}</Link>
                            <Link className={'nav-link'} onClick={() => onNavLinkClick('/game')} to={'/game'}>{intl.formatMessage(messages.learnGameLabel)}</Link>
                            <Link className={'nav-link'} onClick={() => onNavLinkClick('/message')} to={'/message'}>{intl.formatMessage(messages.messageBoardLabel)}</Link>
                            <Link className={'nav-link'} onClick={() => onNavLinkClick('/checkin')} to={'/checkin'}>{intl.formatMessage(messages.dailyCheckInLabel)}</Link>
                        </Nav>
                    </Container>
                </Navbar>
            </Col>
        </Row>
    );
}

export default NavigationBar;